'use client';

import { createContext, ReactNode } from 'react';

type ContextType = {
  locale: string;
};
export const i18nContext = createContext<ContextType | null>(null);

export const I18NProvider = ({
  locale,
  children,
}: {
  locale: string;
  children: ReactNode;
}) => {
  return (
    <i18nContext.Provider
      value={{
        locale,
      }}
    >
      {children}
    </i18nContext.Provider>
  );
};
